export default __webpack_public_path__ + "static/media/E10plus.f1eb8161.svg";